import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

type PageItem = number | "...";

export interface Props {
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  } | null;
  onChange: (page: number) => void;
}

export const Pagination = ({ pagination, onChange }: Props) => {
  if (!pagination) return null;

  const { page, totalPages } = pagination;

  const createPages = (): PageItem[] => {
    const pages: PageItem[] = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    pages.push(1);

    if (page > 3) pages.push("...");

    const start = Math.max(2, page - 2);
    const end = Math.min(totalPages - 1, page + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (page < totalPages - 2) pages.push("...");

    pages.push(totalPages);

    return pages;
  };

  const pages = createPages();

  return (
    <div className="flex flex-wrap items-center justify-center gap-1 sm:gap-2">
      {/* Prev */}
      <button
        type="button"
        className="h-8 w-8 sm:h-10 sm:w-10 border border-gray-200 rounded-xl bg-gray-100 flex items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        <FaAngleLeft className="text-sm sm:text-xl text-gray-700" />
      </button>

      {pages.map((item, index) =>
        item === "..." ? (
          <span key={`dot-${index}`} className="px-1 sm:px-2 text-sm text-gray-500">
            ...
          </span>
        ) : (
          <button
            key={item}
            onClick={() => onChange(item)}
            className={`h-8 w-8 sm:h-10 sm:w-10 text-sm border border-gray-200 rounded-xl cursor-pointer transition-colors duration-200 ${page === item ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
          >
            {item}
          </button>
        ),
      )}

      {/* Next */}
      <button
        type="button"
        className="h-8 w-8 sm:h-10 sm:w-10 border border-gray-200 rounded-xl bg-gray-100 flex items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        <FaAngleRight className="text-sm sm:text-xl" />
      </button>
    </div>
  );
};
